import { render, staticRenderFns } from "./p07.vue?vue&type=template&id=bdaae008&scoped=true&"
import script from "./p07.vue?vue&type=script&lang=js&"
export * from "./p07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaae008",
  null
  
)

export default component.exports